import { combineReducers } from 'redux';
import { isLoadingReducer } from 'store/reducerUtils';
import { upsertClientPaySettings } from './actions';

const isUpdating = isLoadingReducer(upsertClientPaySettings);

export const paySettings = combineReducers({
    isUpdating,
});
